import React from 'react'
import { Global, css } from '@emotion/core'
import { useTheme } from '@material-ui/core/styles'

export const ResetCss = () => {
	const { typography } = useTheme()
	return (
		<Global
			styles={css`
				body {
					font-family: ${typography.fontFamily};
					height: 100%;
					margin: 0;
					width: 100%;
					background: #ffffff;
				}

				header,
				footer,
				header a {
					font-family: ${typography.fontFamily};
				}

				a {
					text-decoration: none;
				}

				blockquote,
				em,
				table,
				tbody,
				td,
				tfoot,
				th,
				thead,
				time,
				tr,
				tt {
					margin: 0;
					padding: 0;
					border: 0;
					font-size: 100%;
					font: inherit;
					vertical-align: baseline;
				}
			`}
		/>
	)
}
